// Seeded AI demo answers (~80% path). Prewritten, realistic responses keyed by
// simple keyword matching. The rule-based engine (aiRules.js) covers the rest.

export const SEEDED_ANSWERS = [
  {
    match: ["slow", "slow-moving", "dead stock", "not sold", "old stock"],
    answer:
      "A few SKUs haven't moved in 90+ days — mostly heavy antique bangles and one gents kada. Consider a festive bundle, a small making-charge waiver, or a buy-back nudge to your top customers.",
  },
  {
    match: ["recommend", "suggestion", "necklace under", "show me", "match"],
    answer:
      "Based on recent rose-gold and diamond preferences, the strongest matches are the 18K Diamond Necklace (Solitaire), the 22K Temple Necklace, and the Diamond Heart Pendant — all in stock and within a typical bridal budget.",
  },
  {
    match: ["festival", "diwali", "offer", "campaign", "coupon", "promotion"],
    answer:
      "For the upcoming festive window, a tiered coupon works well: ₹2,000 off above ₹75,000 and ₹6,000 off above ₹2,00,000. Target lapsed customers (no visit in 6 months) first — that segment converts best on metal-weight offers.",
  },
  {
    match: ["margin", "profit", "profitability"],
    answer:
      "Margins are healthiest on making-charge-heavy items (studded pieces, filigree bracelets) and thinnest on plain coins and chains. Repairs and custom orders are carrying this month's blended margin upward.",
  },
];

export const AI_DISCLAIMER =
  "This is a demo AI preview — answers are illustrative and generated from the sample dataset, not a live model.";

export function findSeeded(question) {
  const q = String(question || "").toLowerCase();
  for (const entry of SEEDED_ANSWERS) {
    if (entry.match.some((kw) => q.includes(kw))) return entry.answer;
  }
  return null;
}
